export default __webpack_public_path__ + "static/media/simon-english-48nerZQCHgo-unsplash.0b1f2d24.jpg";